"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiscountUnits = void 0;
var DiscountUnits;
(function (DiscountUnits) {
    DiscountUnits["PERCENTAGE"] = "%";
    DiscountUnits["EURO"] = "\u20AC";
})(DiscountUnits = exports.DiscountUnits || (exports.DiscountUnits = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRGlzY291bnRVbml0cy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9EaXNjb3VudFVuaXRzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLElBQVksYUFHWDtBQUhELFdBQVksYUFBYTtJQUN2QixpQ0FBZ0IsQ0FBQTtJQUNoQixnQ0FBVSxDQUFBO0FBQ1osQ0FBQyxFQUhXLGFBQWEsR0FBYixxQkFBYSxLQUFiLHFCQUFhLFFBR3hCIn0=